import { useFileDownload, useFilePreview } from 'api/requests';
import { openAsyncLink } from 'helpers';

import { DocumentsTable, DocumentsTableProps } from '../../components';

export interface DocumentsTableFeatureProps
  extends Omit<DocumentsTableProps, 'onClickDownload' | 'onClickPreview'> {}

export const DocumentsTableFeature = (props: DocumentsTableFeatureProps) => {
  const { getFileLink: getPreviewFileLink } = useFilePreview();
  const { getFileLink: getDownloadFileLink } = useFileDownload();

  const onClickPreview = async (item: { id: string }) => {
    openAsyncLink(() => getPreviewFileLink(item.id));
  };
  const onClickDownload = async (item: { id: string }) => {
    openAsyncLink(() => getDownloadFileLink(item.id));
  };

  return (
    <DocumentsTable
      {...props}
      onClickDownload={onClickDownload}
      onClickPreview={onClickPreview}
    />
  );
};
